import React from 'react'
import { useDispatch } from 'react-redux'
import { FormControlLabel, Checkbox, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { changeFilters } from '@store/slices/Dashboard.slice'

const filters = [
    {
        label: 'completed',
        value: 'completed',
    },
    {
        label: 'pending-others',
        value: 'pendingOthers',
    },
    {
        label: 'pending',
        value: 'pending',
    },
    {
        label: 'rejected',
        value: 'rejected',
    },
]

const EnvelopFilterPanel: React.FC = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    return (
        <>
            {filters.map((item, index) => (
                <FormControlLabel
                    key={index}
                    control={<Checkbox size="small" onChange={() => dispatch(changeFilters(item.value))} />}
                    label={
                        <Typography variant="body2" color="primary">
                            {t(`filters.${item.label}`)}
                        </Typography>
                    }
                />
            ))}
        </>
    )
}

export default EnvelopFilterPanel
